import React from 'react';

const SvgFacebook = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 9 19" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8.395 9.445h-2.48v9.086H2.157V9.445H.369V6.25h1.788V4.184c0-1.477.702-3.791 3.791-3.791l2.784.011v3.1h-2.02c-.331 0-.797.166-.797.87v1.88h2.808l-.328 3.19z"
    />
  </svg>
);

export default SvgFacebook;
